<div class="signup-page">

  <!-- HERO / SIGNUP SECTION -->
  <section class="signup-section">

    <div class="signup-container">

      <!-- LEFT CONTENT -->
      <div class="signup-content">

        <div class="brand-icon">
          <i class="bi bi-envelope-paper"></i>
        </div>

        <h1>
          Start Your Email API Journey
        </h1>

        <p class="signup-description">
          Get started with MALtech Email API and build reliable,
          scalable email communication for your business.
        </p>


        <div class="signup-benefits">

          <div class="benefit">
            <i class="bi bi-check-lg"></i>
            <span>Reliable transactional email delivery</span>
          </div>

          <div class="benefit">
            <i class="bi bi-check-lg"></i>
            <span>Powerful Email API integration</span>
          </div>

          <div class="benefit">
            <i class="bi bi-check-lg"></i>
            <span>Scalable email infrastructure</span>
          </div>

          <div class="benefit">
            <i class="bi bi-check-lg"></i>
            <span>Easy integration with your application</span>
          </div>
            <div class="benefit">
              <i class="bi bi-currency-exchange"></i>
              <span>Local currency billing options</span>
            </div>

            <div class="benefit">
              <i class="bi bi-file-earmark-text"></i>
              <span>GST/taxation-related invoicing support</span>
            </div>

            <div class="benefit">
              <i class="bi bi-headset"></i>
              <span>Ongoing Technical Support</span>
            </div>

        </div>


        <div class="signup-note">

          <h3>
            Get started with MALtech
          </h3>

          <p>
            Tell us about your business and requirements.
            Our team will help you get started with MALtech Email API.
          </p>

        </div>

      </div>


      <!-- RIGHT FORM -->
      <div class="signup-card">

        <div class="form-header">

          <h2>
            Sign up for free
          </h2>

          <p>
            Tell us about yourself and your requirements.
            Our team will help you get started with MALtech Email API.
          </p>

        </div>


<form
  [formGroup]="signupForm"
  (ngSubmit)="submitForm()"
>
  <div class="form-grid">

    <!-- =====================================================
         FULL NAME
         ===================================================== -->
    <div class="form-group">

      <label for="name">
        Full Name <span>*</span>
      </label>

      <input
        id="name"
        type="text"
        formControlName="name"
        placeholder="Enter your full name"
        (input)="onNameInput($event)"
      />

      <small
        *ngIf="
          signupForm.get('name')?.touched &&
          signupForm.get('name')?.errors?.['required']
        "
      >
        Full Name is required.
      </small>

      <small
        *ngIf="
          signupForm.get('name')?.touched &&
          signupForm.get('name')?.errors?.['pattern']
        "
      >
        Full Name can contain only alphabets and spaces.
      </small>

    </div>


    <!-- =====================================================
         BUSINESS EMAIL
         ===================================================== -->
    <div class="form-group">

      <label for="email">
        Business Email <span>*</span>
      </label>

      <input
        id="email"
        type="email"
        formControlName="email"
        placeholder="Enter your business email"
        (input)="onEmailInput($event)"
      />

      <small
        *ngIf="
          signupForm.get('email')?.touched &&
          signupForm.get('email')?.errors?.['required']
        "
      >
        Business email is required.
      </small>

      <small
        *ngIf="
          signupForm.get('email')?.touched &&
          signupForm.get('email')?.errors?.['pattern']
        "
      >
        Please enter a valid business email.
      </small>

    </div>


    <!-- =====================================================
         PHONE
         ===================================================== -->
    <div class="form-group">

      <label for="phone">
        Phone Number <span>*</span>
      </label>

      <input
        id="phone"
        type="text"
        inputmode="numeric"
        maxlength="10"
        formControlName="phone"
        placeholder="Enter your phone number"
        (input)="onPhoneInput($event)"
      />

      <small
        *ngIf="
          signupForm.get('phone')?.touched &&
          signupForm.get('phone')?.errors?.['required']
        "
      >
        Phone number is required.
      </small>

      <small
        *ngIf="
          signupForm.get('phone')?.touched &&
          signupForm.get('phone')?.errors?.['pattern']
        "
      >
        Phone number must be exactly 10 digits.
      </small>

    </div>


    <!-- =====================================================
         COMPANY
         ===================================================== -->
    <div class="form-group">

      <label for="company">
        Company Name <span>*</span>
      </label>

      <input
        id="company"
        type="text"
        formControlName="company"
        placeholder="Enter your company name"
        (input)="onCompanyInput($event)"
      />

      <small
        *ngIf="
          signupForm.get('company')?.touched &&
          signupForm.get('company')?.errors?.['required']
        "
      >
        Company Name is required.
      </small>

      <small
        *ngIf="
          signupForm.get('company')?.touched &&
          signupForm.get('company')?.errors?.['pattern']
        "
      >
        Company Name can contain only alphabets and spaces.
      </small>

    </div>


    <!-- =====================================================
         COUNTRY
         ===================================================== -->
    <div class="form-group">

      <label for="country">
        Country <span>*</span>
      </label>

      <select
        id="country"
        formControlName="country"
      >

        <option value="" disabled>
          Select your country
        </option>

        <option
          *ngFor="let country of countries"
          [value]="country.name"
        >
          {{ country.name }}
        </option>

      </select>

      <small
        *ngIf="
          signupForm.get('country')?.touched &&
          signupForm.get('country')?.errors?.['required']
        "
      >
        Country is required.
      </small>

    </div>


    <!-- =====================================================
         SERVICE
         ===================================================== -->
    <div class="form-group">

      <label for="service">
        Type of Service <span>*</span>
      </label>

      <select
        id="service"
        formControlName="service"
      >

        <option value="" disabled>
          Select a service
        </option>

        <option value="Transactional Email API">
          Transactional Email API
        </option>

        <option value="Bulk Email API">
          Bulk Email API
        </option>

        <option value="Email Integration">
          Email Integration
        </option>

        <option value="Email Automation">
          Email Automation
        </option>

        <option value="Other">
          Other
        </option>

      </select>

      <small
        *ngIf="
          signupForm.get('service')?.touched &&
          signupForm.get('service')?.errors?.['required']
        "
      >
        Service selection is required.
      </small>

    </div>

  </div>


  <!-- =====================================================
       SUBMIT
       ===================================================== -->
  <button
    type="submit"
    class="submit-btn"
    [disabled]="signupForm.invalid || isSubmitting"
  >

    <span *ngIf="!isSubmitting">
      Get Started
    </span>

    <span *ngIf="isSubmitting">
      <i class="bi bi-arrow-repeat"></i>
      Submitting...
    </span>

  </button>


  <!-- =====================================================
       PRIVACY
       ===================================================== -->
  <p class="privacy-text">
    By submitting this form, you agree to be contacted by
    MALtech regarding your enquiry and services.
  </p>

</form>


      </div>

    </div>

  </section>

</div>